import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyC_kqcyZKI7h_p7il_gU4TW2hoywhcp7lo",
  authDomain: "callmeback-cdb7f.firebaseapp.com",
  databaseURL: "https://callmeback-cdb7f.firebaseio.com",
  projectId: "callmeback-cdb7f",
  storageBucket: "callmeback-cdb7f.firebasestorage.app",
  messagingSenderId: "656377478527",
  appId: "1:656377478527:web:0a1ddd1401c3543f196e4a",
  measurementId: "G-WG0586TRL6"
};

const app = initializeApp(firebaseConfig);

export const analytics = getAnalytics(app);
export const messaging = getMessaging(app);